import React from "react";
import owlUrl from "../assets/athena_owl.svg";

// Athena owl mark. Pixel-art barn owl in Mint Classic palette.
// Native aspect is 32×37; if a single `size` is passed we use width=size and
// height=size*37/32 to preserve the aspect ratio.
export default function Owl({ size = 28, opacity = 1, style }) {
  const w = size;
  const h = Math.round(size * 37 / 32);
  return (
    <img
      src={owlUrl}
      className="athena-owl"
      width={w}
      height={h}
      alt="Athena"
      style={{ display: "block", opacity, ...(style || {}) }}
    />
  );
}
